import React from 'react';
import {RolesContainer} from '../../Containers/PermissionControlsContainer';


export const Roles = (props) => {
	return (
		<RolesContainer action="show" show=""/>
	);
}

export default Roles;